<template>
  <!--
    Example Data
      {
        "name" => "ServiceOpsCode",
        "include_match_type" => "ALL",
        "exclude_match_type" => "ANY",
        "include_codes" => [{ "code" => "code", "desc" => "desc" }],
        "exclude_codes" => [{ "code" => "edoc", "desc" => "csed" }],
      }
  -->
  <v-row>
    <v-col class="d-flex" md="6" >
      <custom-search
        title="Ops Code Filter"
        subtitle="Include these Ops Codes"
        v-model="include_codes"
        item-text="desc"
        item-value="code"
        :search-fn="opsCodeSearchFn()"
        :extended-search-fn="extendedOpsCodeSearchFn()"
        :allow-manual-add="true"
        manual-add-text-placeholder="Ops Code Description"
        manual-add-value-placeholder="Ops Code"
      >
        <template v-slot:toolbar>
          <v-toolbar flat color="transparent">
            <v-select
              v-model="include_match_type"
              :items="value.match_types"
              label="Match Type"
              :hint="`RO has ${include_match_type} of these Ops Codes`"
              persistent-hint
              :rules="vruleFieldRequired"
              required
            >
            </v-select>
          </v-toolbar>
        </template>
      </custom-search>
    </v-col>
    <v-col class="d-flex" md="6" >
      <custom-search
        title="Ops Code Filter"
        subtitle="Exclude these Ops Codes"
        v-model="exclude_codes"
        item-text="desc"
        item-value="code"
        :search-fn="opsCodeSearchFn()"
        :extended-search-fn="extendedOpsCodeSearchFn()"
        :allow-manual-add="true"
        manual-add-text-placeholder="Ops Code Description"
        manual-add-value-placeholder="Ops Code"
      >
        <template v-slot:toolbar>
          <v-toolbar flat color="transparent">
            <v-select
              v-model="exclude_match_type"
              :items="value.match_types"
              label="Match Type"
              :hint="`RO has ${exclude_match_type} of these Ops Codes`"
              persistent-hint
              :rules="vruleFieldRequired"
              required
            >
            </v-select>
          </v-toolbar>
        </template>

      </custom-search>
    </v-col>
  </v-row>
</template>

<script>
import validationMixin from '@/validators/validations_mixin'
import CustomSearch from './CustomSearch'
import { mapState } from 'vuex'
import { OpsCodesApi } from '@/services'

export default {
  name: 'ops-code-search',
  inputType: 'ops_code_search',
  components: {
    [CustomSearch.name]: CustomSearch
  },
  mixins: [validationMixin],
  props: {
    value: {
      type: Object,
      require: true
    },
    paramName: {
      type: String,
      require: true
    },
    modelValue: {
      type: Object,
      require: true
    },
    errorMessages: {
      type: Array
    }
  },
  data: function () {
    return {}
  },
  computed: {
    ...mapState('DealerStore', ['dealer']),
    include_codes: {
      get () {
        // if includes_codes has no value, send an empty array as value for the initial default setting
        if (!this.modelValue.include_codes) {
          this.$emit('update-query-param-value', { name: this.paramName, key: 'include_codes', value: [] })
          return []
        } else {
          return this.modelValue.include_codes
        }
      },
      set (val) {
        this.$emit('update-query-param-value', { name: this.paramName, key: 'include_codes', value: val })
      }
    },
    include_match_type: {
      get () {
        return this.modelValue.include_match_type
      },
      set (val) {
        this.$emit('update-query-param-value', { name: this.paramName, key: 'include_match_type', value: val })
      }
    },
    exclude_codes: {
      get () {
        // if excludes_codes has no value, send an empty array as value for the initial default setting
        if (!this.modelValue.exclude_codes) {
          this.$emit('update-query-param-value', { name: this.paramName, key: 'exclude_codes', value: [] })
          return []
        } else {
          return this.modelValue.exclude_codes
        }
      },
      set (val) {
        this.$emit('update-query-param-value', { name: this.paramName, key: 'exclude_codes', value: val })
      }
    },
    exclude_match_type: {
      get () {
        return this.modelValue.exclude_match_type
      },
      set (val) {
        this.$emit('update-query-param-value', { name: this.paramName, key: 'exclude_match_type', value: val })
      }
    }
  },
  methods: {
    opsCodeSearchFn () {
      const dealerId = this.dealer.id
      return async function (searchTerm) {
        const resp = await OpsCodesApi.searchOpsCodes(dealerId, searchTerm)
        return resp.data.map(opsCode => { return { code: opsCode.ops_code, desc: opsCode.ops_desc } })
      }
    },
    extendedOpsCodeSearchFn () {
      return async function (searchTerm) {
        const resp = await OpsCodesApi.searchExtendedOpsCodes(searchTerm)
        return resp.data.map(opsCode => { return { code: opsCode.ops_code, desc: opsCode.ops_desc } })
      }
    }
  }
}
</script>
